export const getMatrizResiduos = (state) => state.matrizResiduos.lista
export const getIsCarregandoListaMatrizResiduos = (state) => state.matrizResiduos.isCarregandoLista
export const getIsSavingMatrizResiduos = (state) => state.matrizResiduos.isSaving
